<template>
  <pageContent class="contacto">
    <div class="contacto-main">
      <div class="row-text fade-in">
        <h1 class="font-blod" style="white-space: nowrap">
          Cuéntanos tu proyecto, tu idea, tu sueño
        </h1>
        <h1 class="font-blod black">y te ayudaremos a llevarlo a cabo</h1>
      </div>
      <div class="text-center fade-in">
        <i>Nuestra finalidad es dar respuesta profesional a todos los procesos intervinientes en la construcción.</i>
      </div>
      <div class="row">
        <div>
          <div class="icon-text">
            <img class="icon" src="../../assets/img/icon7.svg" />
            <span class="name1 fade-in">Llámanos</span>
            <el-link class="fade-in" href="tel:603440332">603 440 332</el-link>
          </div>
          <el-link class="fade-in" href="mailto:info@maragonconstruccion.es" :router="false" :underline="false">
              info@maragonconstruccion.es
          </el-link>
          <!--<div class="icon-text">
            <img class="icon" src="../../assets/img/icon8.svg" />
            <span class="name1 fade-in">Escríbenos</span>
            <el-link class="fade-in" href="mailto:smartin@maragonconstruccion.es">
              info@maragonconstruccion.es
            </el-link>
          </div>-->
        </div>
      </div>
      <div class="form no-bg">
        <!-- <img src="@/assets/img/footer2.svg" /> -->
        <el-image
          class="form-bg"
          :src="require('@/assets/img/cardbg.jpg')"
        ></el-image>
        <div class="form-content">
          <h1>
            <div v-for="name in form.name.split(',')" :key="name">
              {{ name }}
            </div>
          </h1>
          <div class="icon-text">
            <img src="@/assets/img/footer5.svg" />
            <el-link class="fade-in" :href="`tel:${form.tel}`">{{ form.tel }}</el-link>
          </div>
          <div class="icon-text">
            <img src="@/assets/img/footer4.svg" />
            <div>
              <!--<el-link v-for="email in form.email.split(',')" :key="email" :href="email">
                {{ email }}
              </el-link>-->
              <el-link v-for="email in form.email.split(',')" :key="email" :href="`mailto:${email}`" :router="false" :underline="true">
                {{ email }}
              </el-link>
            </div>
          </div>
          <div class="icon-text">
            <img src="@/assets/img/footer9.svg" />
            <div>
              <el-link
                v-for="link in form.link.split(',')"
                :key="link"
                :href="link"
                target="_blank"
              >
                maragonconstruccion.es
              </el-link>
            </div>
          </div>
          <!--<div class="icon-text">
            <img src="@/assets/img/footer9.svg" />
            <div>
              <el-link v-for="link in form.link.split(',')" :key="link" :href="link">
                {{ link }}
              </el-link>
            </div>
          </div>-->
          <!-- Nuevo bloque con código QR y texto -->
          <div class="contact-qr">
            <div class="contact-text">
              <span>Agrégame a tus contactos</span>
            </div>
            <div class="contact-image">
              <img src="../../assets/img/qr_vcard_carlos.png" alt="Código QR" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </pageContent>
</template>

<script>
import pageContent from "@/components/pageContent.vue";
export default {
  name: "SergioMartin",
  components: {
    pageContent,
  },
  data() {
    return {
      form: {
        name: "Carlos Muñoz García",
        tel: "687 832 194",
        email:"carlos@maragonconstruccion.es",
        link: "https://maragonconstruccion.es/#/home",
      },
    };
  },
  mounted() {
    // http://localhost:8080/#/card?name=a&tel=1&email=1&link=1
    console.log(this.$route.query);
    this.$route.query && (this.form = this.$route.query);
  },
  methods: {
    openPage(idx) {
      this.$router.push({ path: `/obras?row=${idx}` });
    },
  },
};
</script>
<style lang="scss" scoped>
.contacto-main {
  position: relative;
  top: -112px;
  .row-text {
    text-align: center;
    color: #fff;
    opacity: 0;
    animation-delay: 1s;
    .font-blod {
      font-size: calc(var(--font-size) * 2);
      &.black {
        color: #000000;
      }
    }
  }
  .text-center {
    margin-top: 80px;
    font-size: 50px;
    opacity: 0;
    animation-delay: 1.2s;
  }
  .row {
    display: flex;
    justify-content: center;
    padding-top: 90px;
    padding-bottom: 50px;
    .icon-text {
      display: flex;
      align-items: center;
      margin-bottom: 50px;
      .icon {
        width: 117px;
        height: 117px;
        margin-right: 80px;
      }
      .name1 {
        display: inline-block;
        width: 170px;
        margin-right: 40px;
        opacity: 0;
        animation-delay: 1s;
      }
      .el-link {
        font-family: font_blod;
        font-size: var(--font-size);
        color: #000;
        font-weight: bolder;
        opacity: 0;
        animation-delay: 1s;
      }
    }
  }
  .form {
    position: relative;
    .form-bg {
      position: relative;
      top: 0;
      left: 0;
      z-index: -1;
    }
    h1 {
      color: #fff;
      margin-bottom: 80px;
      div {
        font-size: calc(var(--font-size) + 20px);
      }
    }
    .form-content {
      position: absolute;
      right: 70px;
      top: 70px;
      width: 68%;
      padding: 70px;
      * {
        word-wrap: break-word;
        font-family: font_blod;
      }
    }
    .icon-text {
      display: flex;
      align-items: start;
      margin-bottom: 30px;
      img {
        width: 50px;
        height: 50px;
        margin-right: 20px;
      }
      
      .el-link {
        font-size: var(--font-size);
        color: #000;
        font-weight: bolder;
       &::v-deep *{
          word-wrap: break-word;
        }
      }
    }
  }
  /* Estilos nuevos para el bloque QR */
  .contact-qr {
    display: flex;
    align-items: center;
    margin-top: 20px;
    .contact-text {
      font-size: 18px;
      margin-right: 20px;
    }
    .contact-image img {
      width: 200px;
      height: 200px;
    }
  }
}
</style>